// Conversão tokens -> R$ (taxa do plano Plus: R$ 79,90 / 5.000 tokens)
export const TOKEN_PRICE_BRL = 79.9 / 5000;

export function tokensToBRL(tokens) {
    return (Number(tokens) || 0) * TOKEN_PRICE_BRL;
}

export function formatBRL(value) {
    return (Number(value) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}
